<template>
  <svg :width="width" :Height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="comparison">
      <path id="Vector"
        d="M7.99995 14L7.99994 14.7502C7.99993 15.5786 7.32836 16.2501 6.49994 16.2501H5.25001C4.42158 16.2501 3.75 15.5786 3.75001 14.7501L3.75006 5.24999C3.75006 4.42157 4.42163 3.75 5.25006 3.75H6.49992C7.32834 3.75 7.99992 4.42157 7.99992 5.25V6"
        stroke="#5E6678" style="stroke:#5E6678;stroke:color(display-p3 0.3686 0.4000 0.4706);stroke-opacity:1;"
        stroke-width="1.5" stroke-linecap="round" />
      <path id="Vector_2"
        d="M12.0001 14V14.7501C12.0001 15.5786 12.6717 16.2501 13.5001 16.2501H14.75C15.5784 16.2501 16.25 15.5786 16.25 14.7501L16.2499 5.24999C16.2499 4.42157 15.5784 3.75 14.7499 3.75H14.1249H13.5C12.6716 3.75 12 4.42157 12 5.25V6"
        stroke="#5E6678" style="stroke:#5E6678;stroke:color(display-p3 0.3686 0.4000 0.4706);stroke-opacity:1;"
        stroke-width="1.5" stroke-linecap="round" />
      <path id="Vector 989" d="M6.39648 12.0359L8.6453 8.73161L11.5756 10.9626L13.605 7.6123" stroke="#5E6678"
        style="stroke:#5E6678;stroke:color(display-p3 0.3686 0.4000 0.4706);stroke-opacity:1;" stroke-width="1.5"
        stroke-linecap="round" stroke-linejoin="round" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ComparaitiveIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>
